import * as React from "react";

import { UnitLabelContainer } from "../../UnitLabel/UnitLabelContainer";
import { AbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { withResolvePaths } from "../../../withResolvePaths";

import { Root, Title } from "./MultipleUnitCaption.styles";

interface MultipleUnitCaptionProps {
    bindingPath: AbsoluteModelPath;
    children: React.ReactNode;
}

/***
 * withResolvePaths - Добавлен чтобы понять, что может быть props.bindingPath.isResolved() = false, для случая когда
 * этот caption оказался внутри defaultContent-а множественного Unit-а
 */
export const MultipleUnitCaption = withResolvePaths(
    (props: MultipleUnitCaptionProps): JSX.Element => (
        <Root>
            <Title>{props.children}</Title>
            {props.bindingPath.isResolved() && <UnitLabelContainer bindingPath={props.bindingPath} />}
        </Root>
    )
);
